export const EQUIPMENT_TYPES = {
  EXTINGUISHER: 'extinguisher',
  RIA: 'ria',
  BDI: 'bdi',
  CABINET: 'cabinet',
};

export const EQUIPMENT_STATUS = {
  OPERATIONAL: 'operational',
  MAINTENANCE_REQUIRED: 'maintenance_required',
  OUT_OF_SERVICE: 'out_of_service',
  EXPIRED: 'expired',
};

export const EXTINGUISHER_TYPES = {
  POWDER: 'Poudre ABC',
  CO2: 'CO2',
  WATER: 'Eau pulvérisée',
  FOAM: 'Mousse',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  CLIENT: 'client',
};

export const NOTIFICATION_TYPES = {
  MAINTENANCE_DUE: 'maintenance_due',
  EXPIRATION_WARNING: 'expiration_warning',
  EQUIPMENT_ADDED: 'equipment_added',
  REPORT_READY: 'report_ready',
};

export const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
  API: 'yyyy-MM-dd',
  DATETIME: 'dd/MM/yyyy HH:mm',
};

export const COLORS = {
  PRIMARY: '#ff0000',
  SECONDARY: '#cc0000',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  DANGER: '#ef4444',
  INFO: '#3b82f6',
};

export const EQUIPMENT_COLORS = {
  extinguisher: '#ff0000',
  ria: '#3b82f6',
  bdi: '#10b981',
  cabinet: '#f59e0b',
};

export const EQUIPMENT_ICONS = {
  extinguisher: '🧯',
  ria: '🚿',
  bdi: '💧',
  cabinet: '🗄️',
};

export const EQUIPMENT_TYPE_LABELS = {
  extinguisher: 'Extincteur',
  ria: 'RIA',
  bdi: 'BDI',
  cabinet: 'Armoire',
};

